import { FC, useState, useEffect } from 'react';
import styled from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import Button from '@/components/UI/Button';

const WhatsEcoCredits: FC = () => {
    const { useRouter, useLang, Link, isMobile, getSystemTime } = useGlobal();
    const { locale } = useRouter();

    const { t } = useLang('membership.whatsecocredits');

    return (
        <div className={styled.whats_ecocredits} id="EcoCredit_Program">
            <div className="whats_eco_text">
                <p className="subtitle">{t('subtitle')}</p>
                <h6 className="title">{t('title')}</h6>
                <p className="desc">{t('desc')}</p>
            </div>
            <div className="whats_eco_img">
                <NextImage src={require(`@publicLocal/ecocredits/membership_ecocredits.png`)} alt={t('title')} aria-label={t('title')} />
            </div>
        </div>
    );
};

export default WhatsEcoCredits;
